module.exports = __webpack_public_path__ + "img/vue_vuetify.ce0d137e.jpg";